module.exports = __webpack_public_path__ + "static/media/REAL.5667f148.png";